import { render, staticRenderFns } from "./VImagePreview.vue?vue&type=template&id=e164ed0a&"
import script from "./VImagePreview.vue?vue&type=script&lang=js&"
export * from "./VImagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports